import { render, staticRenderFns } from "./LegendaryBinding.vue?vue&type=template&id=b35a54f2&scoped=true"
import script from "./LegendaryBinding.vue?vue&type=script&lang=js"
export * from "./LegendaryBinding.vue?vue&type=script&lang=js"
import style0 from "./LegendaryBinding.vue?vue&type=style&index=0&id=b35a54f2&prod&lang=css"
import style1 from "./LegendaryBinding.vue?vue&type=style&index=1&id=b35a54f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a54f2",
  null
  
)

export default component.exports